export type AppLocationParts = { pathname: string; search?: string; hash?: string };

export function fullLocationPath(location: AppLocationParts): string {
  return `${location.pathname}${location.search ?? ""}${location.hash ?? ""}`;
}

export function appReturnPath(state: unknown, fallback = "/app/catalog"): string {
  if (typeof state !== "object" || state === null) return fallback;
  const from = (state as { from?: unknown }).from;
  return typeof from === "string" && (from === "/app" || from.startsWith("/app/")) ? from : fallback;
}
